import cn from 'clsx';
import { observer } from 'mobx-react-lite';

import { ActionPopover } from 'components/ActionPopover';
import { favoritesFAQ } from 'constants/pages';
import { useStore } from 'hooks/useStore';
import { TabsContent } from 'layout/TabsContent';
import { interpolate } from 'utils/string/format';

import { Content } from './Content';
import { FavoritesIcon } from './FavoritesIcon';

import css from './Favorites.module.css';

const Favorites = () => {
  const {
    app: { i18n, env },
    favorites,
  } = useStore();

  const hasLoads = Boolean(favorites.count > 0);

  return (
    <div className={cn(css.container, { [css.container_minHeight]: !hasLoads })}>
      <div className={css.header}>
        <span className={cn(css.about)}>{i18n.favorites.about}</span>

        <div className={css.links}>
          <ActionPopover
            alternateAction={i18n.actionPopover.delete.atlernate}
            primaryAction={i18n.actionPopover.delete.primary}
            title={i18n.favorites.deleteUnactual.popover}
            onConfirm={favorites.removeUnactualFavorites}
          >
            <button className={cn('glz-link', css.link)}>{i18n.favorites.deleteUnactual.button}</button>
          </ActionPopover>

          <ActionPopover
            alternateAction={i18n.actionPopover.delete.atlernate}
            primaryAction={i18n.actionPopover.delete.primary}
            title={i18n.favorites.deleteAll.popover}
            onConfirm={favorites.removeAllFavorites}
          >
            <button className={cn('glz-link', css.link)}>{i18n.favorites.deleteAll.button}</button>
          </ActionPopover>

          <a
            className={cn('glz-link glz-is-gray', css.link, css.more)}
            href={interpolate(favoritesFAQ, { env })}
            rel="noreferrer"
            target="_blank"
          >
            {i18n.favorites.more}
          </a>
        </div>
      </div>

      {!hasLoads && (
        <TabsContent.NoContent
          className={css.noContent}
          desc={''}
          icon={<FavoritesIcon />}
          title={i18n.favorites.noContent.title}
          titleSize={3}
        />
      )}
    </div>
  );
};

Favorites.Content = Content;

const connected = observer(Favorites);

export { connected as Favorites };
